'use strict';

/**
 * Validation for the N-Drip High Pressure sensor's Pressure Boundaries
 * (Max/Min) inputs.
 *
 * The configuration is invalid when Max <= Min (equal values are invalid).
 * Blank / non-numeric values are NOT this rule's concern: when either field
 * cannot be parsed as a number the rule is inactive (returns false) and
 * whatever required/number validation already exists applies unchanged.
 *
 * Kept as a plain CommonJS helper (no React / webpack aliases) so it can be
 * unit-tested with `node --test`.
 *
 * @param {string|number} maxValue - Max Value field value.
 * @param {string|number} minValue - Min Value field value.
 * @returns {boolean} true when the boundaries are invalid (Max <= Min).
 */
const isHighPressureBoundariesInvalid = (maxValue, minValue) => {
  const max = parseFloat(maxValue);
  const min = parseFloat(minValue);
  if (isNaN(max) || isNaN(min)) {
    return false;
  }
  return max <= min;
};

module.exports = { isHighPressureBoundariesInvalid };
